import { useEffect, useRef } from 'react';

/** Calls `onEscape` when Escape is pressed while `enabled`; for hand-built overlays
 * (Radix dialogs already close on Escape themselves). */
export function useEscapeKey(onEscape, enabled = true) {
  const ref = useRef(onEscape);
  ref.current = onEscape;
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (e) => { if (e.key === 'Escape' && ref.current) ref.current(e); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [enabled]);
}
